var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"border-solid border border-gray-300 p-3",style:(("max-width: " + (_vm.maxWidth != 0 ? _vm.maxWidth + 'px' : '')))},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }